import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

// PrimeNG used within the 5 advanced sub-components
import { ToggleSwitch } from 'primeng/toggleswitch';
import { InputTextModule } from 'primeng/inputtext';
import { Select } from 'primeng/select';
import {InputText } from 'primeng/inputtext';
import { TooltipModule } from 'primeng/tooltip';
import { DividerModule } from 'primeng/divider';
import { Tabs } from 'primeng/tabs';
import { Textarea } from 'primeng/textarea';


// Advanced sub-components only (not the container yet)
import { AdvancedAdConfigurationComponent } from './offer-set-configuration/offer-set-configuration.component';
import { AdvancedPageConfigurationComponent } from './page-configuration/page-configuration.component';
import { AdvancedLeadManagementComponent } from './lead-management/lead-management.component';
import { AdvancedServiceCategoriesComponent } from './service-categories/service-categories.component';
import { AdvancedGeneralSettingsComponent } from './general/advanced-general-settings.component';
import { AdvancedDisclosuresComponent } from './disclosures/disclosures.component';
import {ButtonModule} from 'primeng/button';
import {ProgressSpinnerModule} from 'primeng/progressspinner';
import {DialogModule} from 'primeng/dialog';

@NgModule({
  declarations: [
    AdvancedAdConfigurationComponent,
    AdvancedPageConfigurationComponent,
    AdvancedLeadManagementComponent,
    AdvancedGeneralSettingsComponent,
    AdvancedDisclosuresComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,

    // PrimeNG used by these sub-components
    ToggleSwitch,
    InputTextModule,
    Select,
    Tabs,
    InputText,
    TooltipModule,
    DividerModule,
    Textarea,
    ButtonModule,
    ProgressSpinnerModule,
    AdvancedServiceCategoriesComponent,
  ],
  exports: [
    // Export so AdvancedSettingsComponent (in AppModule) can use them
    AdvancedAdConfigurationComponent,
    AdvancedPageConfigurationComponent,
    AdvancedLeadManagementComponent,
    AdvancedGeneralSettingsComponent,
    AdvancedServiceCategoriesComponent,
    AdvancedDisclosuresComponent,
  ]
})
export class AdvancedSettingsFeatureModule {}
